import { render, staticRenderFns } from "./Presential.vue?vue&type=template&id=24e7f0c1&scoped=true&"
import script from "./Presential.vue?vue&type=script&lang=js&"
export * from "./Presential.vue?vue&type=script&lang=js&"
import style0 from "./Presential.vue?vue&type=style&index=0&id=24e7f0c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7f0c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VLayout,VProgressCircular,VRow})
